<template>
  <Dialog v-model="showConfirmationDialog" :yes-or-no="yesNoConfirmation" @ok="ok">
    <p>{{ dialogMessage }}</p>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from './Dialog.vue';
import { showConfirmationDialog, dialogMessage, yesNoConfirmation, dialogOk } from '../utils/frontend';

const ok = (yesOrNo?: boolean) => {
  dialogOk(yesOrNo);
};
</script>
